import React, { Component } from 'react';
import { MainDashboard } from './pages/MainDashboard.js';
import { Login } from './pages/Login.js';
import { LogisticCreator } from './pages/LogisticCreator.js';
import { TruckDispatcher } from './pages/TruckDispatcher.js';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';

import trucksData  from './data/Trucks.js';
import routesData  from './data/Routes.js';

class App extends Component {

    constructor(props) {
      super(props);

      routesData.routesList.map((route) => {
        route.pathColor = this.getRandomColor();
        if (route.vectorPath) {
          route.vectorPath.map((vpath) => {
            vpath.reverse();
            return null;
          });
        }
        return null;
      })

      trucksData.truksList.map((truck) => {
        if (truck.vectorPath) {
          truck.vectorPath.map((vpath) => {
            vpath.reverse();
            return null;
          });
        }
        return null;
      })
    }

    getRandomColor = () => {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    }

    addRouteToRoutelist = (route) => {
      //console.log('Add route to list');
      //console.log(route);
      routesData.routesList.push(route);
    }

    render() {
        return(
            <Router>
              <div className="container-fluid">
                  <Route exact path="/" component={Login}/>
                  <Route exact path="/login" component={Login}/>
                  <Route exact path="/dashboard" component={MainDashboard}/>
                  <Route exact path="/logisticcreator" render={ (props) => <LogisticCreator history={props.history} trucksData={trucksData} onAddRoute={this.addRouteToRoutelist}/>}/>
                  <Route exact path="/truckdispatcher" component={TruckDispatcher}/>
                  <Route exact path="/recipientapp" component={MainDashboard}/>
                  <Route exact path="/truckerapp" component={MainDashboard}/>

              </div>
            </Router>
        );
    }
}
;

export default App;



// WEBPACK FOOTER //
// ./src/App.js